<template>
  <section class="operation-summary">
    <div class="card-content">
      <form @submit.prevent="submit">
        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">Value</label>
          </div>
          <div class="field-body">
            <b-field>{{ total | numberPriceFormatterWithDollarSign }}</b-field>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">Activity Owner</label>
          </div>
          <div class="field-body">
            <b-field>
                    
              <b-select expanded placeholder="Please Select" 
                v-model="form.firm_owner_id" 
                @input="onActivityOwnerInput" 
                :disabled="!canManageOrders"
                v-if="order.status === 'BLRQ' && isBelongToIssuingFirm">
                  <option value="" v-if="notYetSelected">Not yet selected</option>
                  <option value="" v-else-if="multipleOwnersFirm">Multiple Activity Owners</option>
                  <option value="" v-else-if="!multipleOwnersFirm">Activity Owner is not selected for all operations</option>
                  <option :value="firm.child_id" v-for="(firm, key) in associated">{{ firm.firm_name.name }}</option>
              </b-select>

              <b-select expanded placeholder="Please Select" 
                v-else
                v-model="form.firm_owner_id" 
                :disabled="!canManageOperationsBoolean || !order.editable">
                  <option value="" v-if="notYetSelected">Not yet selected</option>
                  <option value="" v-else-if="multipleOwnersFirm">Multiple Activity Owners</option>
                  <option value="" v-else-if="!multipleOwnersFirm">Activity Owner is not selected for all operations</option>
                  <option :value="firm.child_id" v-for="(firm, key) in associated">{{ firm.firm_name.name }}</option>
              </b-select>

            </b-field>

            <!-- <base-select
              :service="firmService"
              fetch-func="all"
              :fetch-params="{ activityOwner: 1 }"
              :value.sync="form.firm_owner_id"
              value-key="id"
              label
              :disabled="!canManageOrders"
              @input:manual="onActivityOwnerInput"
              v-if="order.status === 'BLRQ' && isBelongToIssuingFirm"
              ref="firmList"
            >

              <template
                #defaultOptionLabel="{ option }"
                v-if="notYetSelected"
              >Not yet selected </template>

              <template
                #defaultOptionLabel
                v-else-if="multipleOwnersFirm"
              >Multiple Activity Owners</template>


              <template
                #defaultOptionLabel
                v-else-if="!multipleOwnersFirm"
              >Activity Owner is not selected for all operations</template>

            </base-select>
            <base-select
              :service="firmService"
              fetch-func="all"
              :fetch-params="{ activityOwner: 1 }"
              :value.sync="form.firm_owner_id"
              :disabled="!canManageOperationsBoolean"
              value-key="id"
              label
              v-else
              ref="firmList"
            >

              <template
                #defaultOptionLabel="{ option }"
                v-if="notYetSelected"
              >Not yet selected </template>

              <template
                #defaultOptionLabel
                v-else-if="multipleOwnersFirm"
              >Multiple Activity Owners</template>


              <template
                #defaultOptionLabel
                v-else-if="!multipleOwnersFirm"
              >Activity Owner is not selected for all operations</template>

            </base-select> -->
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label"></label>
          </div>
          <div class="field-body">
            <b-field>
              <b-button
                type="is-info"
                native-type="submit"
                :disabled="!form.firm_owner_id || !canManageOperationsBoolean"
                v-if="user.firmId == order.firm.id"
              >APPLY</b-button>
            </b-field>
          </div>
        </div>

        <b-field label="Ratings" horizontal v-if="canRate">
          <!-- <rating-list :ratings="ratings" :rate="this.rate" :hide-rate-button="hasRating || !canRate" /> -->
          <rating-list :ratings="ratings" :rate="this.rate" :hide-rate-button="hasRating" />
        </b-field>

      </form>
    </div>
  </section>
</template>

<script>
import RatingList from "@/components/Rating/RatingList";
import BaseSelect from "@/components/partials/BaseSelect";
import { FirmService } from "@/services/firm.service";
import { OrderService } from "@/services/order.service";
import { OrderOperationService } from "@/services/orderOperation.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import { AssociatedService } from "@/services/associated.service";

export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    operations: {
      type: Array,
      required: true
    },
    total:{
      default: 0
    }
  },
  components: {
    RatingList,
    BaseSelect
  },
  data: () => ({
    firmService: FirmService,
    orderService: OrderService,
    orderOperationService: OrderOperationService,
    form: {
      firm_owner_id: ''
    },
    sameOwnersFirm: false,
    multipleOwnersFirm:false,
    notYetSelected: true,
    associated: []

  }),
  watch: {
    operations() {
        this.$nextTick(()=>{
          this.setActivityOwner();
        })
    }
  },
  computed: {
    user() {
      return this.$store.state.Auth.user;
    },
    canManageOperationsBoolean() {
      const obj = this.$store.getters['OrderState/getStateByKey']('can_manage_operations');
      return (obj && obj.value);
    },
    ratings() {
      return this.order.ratings || [];
    },
    hasRating() {
      return !!this.ratings.find(rating => rating.createdBy.id == this.user.id);
    },
    canRate() {
      return (
        this.user.firm.id === this.order.createdByFirm.id &&
        // this.canManageOrders &&
        this.$store.getters["Auth/hasFirmPermission"]("can rate orders")
      );
    },
    isBelongToIssuingFirm() {
      return this.$store.state.Auth.user.firm.id === this.order.createdByFirm.id;
    },
    canManageOrders() {
      return this.$store.getters["Auth/hasPermission"]("can manage orders");
    }

  },
  mounted() {
    this.getAssociated();
  },
  methods: {

    getAssociated() {
      // let ids = this.firm.firm.associated.map(element => element.id);
      AssociatedService.getAssociated({id: this.order.created_by_firm_id, includes: 'tags'}).then(response => {
        this.associated = Object.values(response).filter(element => {
          if (element.tags.length) {
            return element.tags.filter(element => element.name.toLowerCase() == 'customer' && element.pivot.archived_at == null).length;
          }else {
            return false;
          }
        });
      });
    },

    async submit() {
      try {
        const updatedOperations = await this.orderOperationService
          .setOwnerFirmid(this.transformedData())
          .then(response => JsonDenormalizer.denormalize(response));
        this.$emit("updateOperaions", updatedOperations);

        this.$buefy.toast.open({
          message: "Order operations has been updated.",
          type: "is-info",
          position: "is-top-right"
        });

      } catch (err) {}
    },
    transformedData() {
      return {
        orderId: this.order.id,
        firm_owner_id: this.form.firm_owner_id,
        ids: this.operations.map(operation => {
          return operation.id;
        }),
        includes: "outcomeCode,responsibilityCode,failureCode,repairCode,activityCode,ownerFirm,ownerFirm.permissions,asset,orderOperationClaimLines",
      };
    },
    setActivityOwner(){
      let ownerFirmIds = [];

      if(this.operations.length > 0){

        this.operations.forEach(operation => {
          ownerFirmIds.push(operation.ownerFirmId);
        });
        // Filter Unique Ids
        let firmId = [...new Set(ownerFirmIds)];
        // Validate if different firmIds
        if(firmId.length == 1){
          this.notYetSelected = !firmId[0]
          this.form.firm_owner_id = firmId[0] ? firmId[0] : '';
          this.multipleOwnersFirm = false

        } else {
          this.notYetSelected = false
          this.multipleOwnersFirm = !firmId.includes(null)
          this.form.firm_owner_id = '';
        }

      }
    },
    async rate(data) {
      try {
        const order = await this.orderService.rate(this.order.id, data).then(response => JsonDenormalizer.denormalize(response));
        
        if (order.ratings) {
          this.$set(this.order, "ratings", order.ratings);
        }
      } catch (err) {
        throw err;
      }
    },
    onActivityOwnerInput() {
      this.$nextTick(() => this.submit());
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Order/OrderOperationSummary.vue